import axios from 'axios';

export const accountReceivableApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-account-receivable/`,
    headers: {
        'Content-Type': 'application/json'
    }
})